import { useMediaQuery } from '@coursera/cds-core';

export const useIsMobileHeader = (): boolean => {
  // This pixel num is not a CDS breakpoint sicne it was used before CDS as the page header breakpoint
  const isMobileHeader = useMediaQuery('@media (max-width:991.95px)');

  return isMobileHeader;
};
